import { useEffect } from 'react';
import type { RemitReport } from 'src/apis/remit-reporting/types';
import { useAxios } from 'src/hooks/use-axios';
import { handleError } from 'src/utils/handle-error';
import { reportToSentry } from 'src/utils/report-to-sentry';

export function useRemitReportHistory(assignedProposalId: number) {
  const reportsRequest = useAxios(
    (axios, baseConfig, assignedProposalId: number) =>
      axios.request<RemitReport[]>({
        ...baseConfig,
        url: `${PRISMA_CONFIG.remitReporting}/api/platform/secondary-reports/proposal/${assignedProposalId}`,
        method: 'GET',
      }),
    {
      neededOnPageLoad: false,
      onError(error) {
        const [_, report] = handleError(error, () => {});
        if (report) reportToSentry(error);
        return error;
      },
    }
  );

  useEffect(() => {
    reportsRequest.execute(assignedProposalId);
    // oxlint-disable-next-line exhaustive-deps
  }, [assignedProposalId]);

  return reportsRequest;
}

type RemitReportHistoryRequest = ReturnType<typeof useRemitReportHistory>;
